import { normalizeCpqRowsForDrawer, normalizeGmRowsForDrawer } from './rowEvidence.js';

export const nextReviewPayload = (review, patch) => ({ ...(review || { notes: [] }), ...patch });
export const listActionsFromPayload = (payload) => (Array.isArray(payload) ? payload : payload?.rows || []);

export const normalizeEvidenceRowsForDrawer = (data = {}, row = {}) => ({
  gmLineItems: normalizeGmRowsForDrawer(data.gmRows || [], row),
  historicalFinalGmLineItems: normalizeGmRowsForDrawer(data.historicalFinalGmRows || [], row),
  cpqLineItems: normalizeCpqRowsForDrawer(data.cpqRows || []),
  appsheetData: data.appsheetData || null,
  appSheetAccounts: data.appSheetAccounts || { rows: [], total: 0 },
  dpeData: data.dpeData || null,
  dpeLineItems: data.dpeData?.products || data.dpeLineItems || [],
  sourceErrors: data.sourceErrors || {},
  sourceMetadata: data.sourceMetadata || null,
  peopleSoftId: data.accountMetadata?.peopleSoftId || data.sourceMetadata?.peopleSoft?.id || row.peopleSoftId || row.peoplesoftId || '',
  peopleSoft: data.accountMetadata?.peopleSoft || data.sourceMetadata?.peopleSoft || null,
});

export const evidenceTotals = (evidenceRows) => {
  const gmTotal = (evidenceRows.gmLineItems || [])
    .filter((line) => line.isBilling)
    .reduce((sum, line) => sum + (Number(line.dealerCost) || 0), 0);
  const historicalFinalGmTotal = (evidenceRows.historicalFinalGmLineItems || [])
    .filter((line) => line.isBilling)
    .reduce((sum, line) => sum + (Number(line.dealerCost) || 0), 0);
  const cpqTotal = (evidenceRows.historicalFinalGmLineItems || []).length
    ? historicalFinalGmTotal
    : (evidenceRows.cpqLineItems || [])
    .filter((line) => line.isBillable !== false && Number(line.budget) > 0 && Number(line.quantity ?? 1) > 0)
    .reduce((sum, line) => sum + (Number(line.budget) || 0), 0);
  const dpeTotal = (evidenceRows.dpeLineItems || [])
    .filter((line) => line.isBilling)
    .reduce((sum, line) => sum + (Number(line.dealerPrice) || 0), 0);
  return {
    gmTotal,
    cpqTotal,
    dpeTotal,
    deltas: {
      gmVsCpq: gmTotal - cpqTotal,
      gmVsDpe: gmTotal - dpeTotal,
      cpqVsDpe: cpqTotal - dpeTotal,
    },
  };
};
